import restService from './restService'

export default {
  getActive () {
    return restService.execute('get', '/v1/employees/all')
  },
  get (id) {
    return restService.execute('get', `/v1/employees/${id}`)
  },
  create (data) {
    return restService.execute('post', '/v1/employees', { user: data })
  },
  update (id, data) {
    return restService.execute('put', `/v1/employees/${id}`, { user: data })
  },
  delete (id) {
    return restService.execute('delete', `/v1/employees/${id}`)
  },
  sendInvitation (id) {
    return restService.execute('put', `/v1/employees/${id}/invitation`)
  },
}
